import * as api from "@client-shared/services/api";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { setAuthLoginTestId } from "./AuthLogin.utils";
import Redirect from "./Redirect";

export const AuthLogin: React.FC = () => {
  const [authorizeUrl, setAuthorizeUrl] = React.useState<string>();
  const { t } = useTranslation();

  React.useEffect(() => {
    const fetchAuthorizeUrl = async () => {
      const url = await api.getAuthorizeUrl();
      setAuthorizeUrl(url);
    };
    void fetchAuthorizeUrl();
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }} data-testid={setAuthLoginTestId("container")}>
      <h1 data-testid={setAuthLoginTestId("title")}>{t("components.AuthLogin.title")}</h1>
      <p data-testid={setAuthLoginTestId("message")}>{t("components.AuthLogin.message")}</p>
      {authorizeUrl && <Redirect to={authorizeUrl} />}
    </div>
  );
};

export default AuthLogin;
